/**
 * Services Section - Mobile Slider Initialization
 * Pattern replicated from transparent-pricing-section.ts
 */

declare global {
    interface Window {
        Swiper: any;
        servicesMobileSwiper?: any;
    }
}

export function initializeServicesMobileSlider(containerElement: HTMLElement | null): void {
    // Only run on mobile screens
    if (window.innerWidth > 991) {
        return;
    }

    if (!containerElement) {
        return;
    }

    // Check if slider already exists
    if (containerElement.querySelector('.services-one__mobile-slider')) {
        return;
    }

    // Get the original swiper container with service cards
    const originalSwiper = containerElement.querySelector('.services-one__carousel');
    if (!originalSwiper) return;

    // Get all service cards
    const serviceCards = Array.from(originalSwiper.querySelectorAll('.swiper-slide'));
    if (serviceCards.length === 0) return;

    // Create new mobile slider container structure
    const sliderContainer = document.createElement('div');
    sliderContainer.className = 'services-one__mobile-slider';

    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'swiper-container services-mobile-swiper-new';

    const swiperWrapper = document.createElement('div');
    swiperWrapper.className = 'swiper-wrapper';

    // Clone and wrap each card in a swiper-slide
    serviceCards.forEach((card) => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';

        // Clone the card content
        const cardClone = card.cloneNode(true) as HTMLElement;
        cardClone.style.width = '100%';

        slide.appendChild(cardClone);
        swiperWrapper.appendChild(slide);
    });

    swiperContainer.appendChild(swiperWrapper);

    // Add pagination
    const pagination = document.createElement('div');
    pagination.className = 'swiper-pagination';
    swiperContainer.appendChild(pagination);

    sliderContainer.appendChild(swiperContainer);

    // Insert after the section title
    const sectionTitle = containerElement.querySelector('.section-title');
    if (sectionTitle && sectionTitle.parentElement) {
        sectionTitle.parentElement.insertBefore(sliderContainer, originalSwiper);
    }

    // Initialize Swiper - wait for it to be available
    const initSwiper = (): void => {
        if (typeof window.Swiper !== 'undefined') {
            const swiperElement = document.querySelector('.services-mobile-swiper-new');
            if (!swiperElement) return;

            // Check if already initialized
            if ((swiperElement as any).swiper) return;

            // Variables to track swipe direction
            let touchStartX = 0;
            let touchStartY = 0;

            const swiper = new window.Swiper('.services-mobile-swiper-new', {
                slidesPerView: 1.15,
                spaceBetween: 15,
                centeredSlides: false,
                loop: false,
                autoplay: false,
                pagination: {
                    el: '.services-one__mobile-slider .swiper-pagination',
                    clickable: true,
                },
                speed: 300,
                effect: 'slide',
                // Swiper touch settings - allow vertical scroll
                simulateTouch: true,
                touchRatio: 1,
                touchAngle: 45,
                threshold: 15,
                touchStartPreventDefault: false,
                touchMoveStopPropagation: false,
                preventClicks: false,
                preventClicksPropagation: false,
                // Custom handling for vertical vs horizontal scroll
                on: {
                    touchStart: function(_swiper: any, event: any) {
                        touchStartX = event.touches[0].clientX;
                        touchStartY = event.touches[0].clientY;
                    },
                    touchMove: function(swiper: any, event: any) {
                        if (!touchStartX || !touchStartY) return;

                        const diffX = Math.abs(event.touches[0].clientX - touchStartX);
                        const diffY = Math.abs(event.touches[0].clientY - touchStartY);

                        // If vertical movement is greater, disable slider and allow page scroll
                        if (diffY > diffX && diffY > 15) {
                            swiper.allowTouchMove = false;
                        } else if (diffX > diffY && diffX > 15) {
                            // Horizontal swipe - enable slider
                            swiper.allowTouchMove = true;
                        }
                    },
                    touchEnd: function(swiper: any) {
                        // Re-enable touch move for next interaction
                        swiper.allowTouchMove = true;
                        touchStartX = 0;
                        touchStartY = 0;
                    }
                }
            });

            window.servicesMobileSwiper = swiper;
        } else {
            // Retry after a short delay if Swiper is not available
            setTimeout(initSwiper, 200);
        }
    };

    setTimeout(initSwiper, 200);
}

